import { render } from "./club-settings.template.html?vue&type=template&id=12ffd51d&scoped=true"
import script from "./ClubSettings.vue?vue&type=script&lang=ts"
export * from "./ClubSettings.vue?vue&type=script&lang=ts"

import "./ClubSettings.vue?vue&type=style&index=0&id=12ffd51d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12ffd51d"

export default script